import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";
import { CartContext } from "./CartContext";
import productData from "../Datas/productData";
import Header from "./Header";
import Footer from "./Footer";
import "../css/checkout.css";

const CURRENCY = "HKD";

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [contact, setContact] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [company, setCompany] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [address, setAddress] = useState("");
  const [address1, setAddress1] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [errors, setErrors] = useState({});
  const { sub } = useLocation().state || {};

  const getProductById = (id) =>
    productData.find((product) => product.id === id);

  const calculateTotal = () =>
    cartItems.reduce((total, item) => {
      const product = getProductById(item.id);
      return product
        ? total + Number.parseFloat(product.price) * item.quantity
        : total;
    }, 0);

  const generateOrderNo = () => {
    const randomPart = window.crypto?.getRandomValues
      ? Array.from(window.crypto.getRandomValues(new Uint32Array(2)))
          .map((value) => value.toString().padStart(10, "0"))
          .join("")
      : Math.random().toString().slice(2).padEnd(20, "0");
    return `${Date.now()}${randomPart}`;
  };

  const handlePlaceOrder = (event) => {
    event.preventDefault();
    const email = contact.trim();
    const newErrors = {};

    if (!email) newErrors.contact = "Enter an email address";
    else if (!/^\S+@\S+\.\S+$/.test(email)) {
      newErrors.contact = "Enter a valid email address";
    }
    if (!countryCode) newErrors.countryCode = "Select a country / region";
    if (!firstName.trim()) newErrors.firstName = "Enter a first name";
    if (!lastName.trim()) newErrors.lastName = "Enter a last name";
    if (!address.trim()) newErrors.address = "Enter an address";
    if (!city.trim()) newErrors.city = "Enter a city";
    if (!postalCode.trim()) newErrors.postalCode = "Enter a ZIP / postal code";
    if (cartItems.length === 0 || calculateTotal() <= 0) {
      newErrors.cart = "Your cart is empty";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const firstProduct = getProductById(cartItems[0].id);
    if (!firstProduct) {
      setErrors({ cart: "The first product in your cart is unavailable" });
      return;
    }

    const siteOrigin = window.location.origin;
    const paymentUrl = new URL("/create_payment.php", siteOrigin);
    paymentUrl.search = new URLSearchParams({
      orderNo: generateOrderNo(),
      amount: calculateTotal().toFixed(2),
      currency: CURRENCY,
      email,
      success_url: `${siteOrigin}/payment?state=success`,
      cancel_url: `${siteOrigin}/payment?state=cancel`,
      title: firstProduct.name,
    }).toString();
    window.location.assign(paymentUrl.toString());
  };

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div id="ban-do-we-exist-to-help-you-be-your-best" className="template-index theme-animate-hover">
      <Header />
      <div className="main-containerCheck">
        <div className="check-custom-checkout-page">
          <div className="left">
            <div className="check-order-info">
              <form onSubmit={handlePlaceOrder} noValidate>
                <div className="form-group">
                  <label htmlFor="contact">Contact</label>
                  <input type="email" id="contact" name="contact" value={contact}
                    placeholder="Email address" onChange={(e) => setContact(e.target.value)}
                    autoComplete="email" aria-invalid={Boolean(errors.contact)} />
                  {errors.contact && <p className="error">{errors.contact}</p>}
                </div>

                <div className="form-group">
                  <label>Delivery</label>
                  <ReactFlagsSelect selected={countryCode} onSelect={setCountryCode} className="check-select" />
                  {errors.countryCode && <p className="error country-error">{errors.countryCode}</p>}
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input type="text" id="firstName" name="firstName" value={firstName}
                      placeholder="First name *" onChange={(e) => setFirstName(e.target.value)}
                      autoComplete="given-name" />
                    {errors.firstName && <p className="error">{errors.firstName}</p>}
                  </div>
                  <div className="form-group">
                    <input type="text" id="lastName" name="lastName" value={lastName}
                      placeholder="Last name *" onChange={(e) => setLastName(e.target.value)}
                      autoComplete="family-name" />
                    {errors.lastName && <p className="error">{errors.lastName}</p>}
                  </div>
                </div>

                <div className="form-group">
                  <input type="text" id="company-name" name="company-name" value={company}
                    onChange={(e) => setCompany(e.target.value)} placeholder="Company name (optional)"
                    autoComplete="organization" />
                </div>
                <div className="form-group">
                  <input type="text" id="address" name="address" value={address}
                    onChange={(e) => setAddress(e.target.value)} placeholder="Address"
                    autoComplete="address-line1" />
                  {errors.address && <p className="error">{errors.address}</p>}
                </div>
                <div className="form-group">
                  <input type="text" id="address1" name="address1" value={address1}
                    onChange={(e) => setAddress1(e.target.value)}
                    placeholder="Apartment, suite, etc. (optional)" autoComplete="address-line2" />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input type="text" id="city" name="city" value={city} placeholder="City"
                      onChange={(e) => setCity(e.target.value)} autoComplete="address-level2" />
                    {errors.city && <p className="error">{errors.city}</p>}
                  </div>
                  <div className="form-group">
                    <input type="text" id="postalCode" name="postalCode" value={postalCode}
                      placeholder="Postal code" onChange={(e) => setPostalCode(e.target.value)}
                      autoComplete="postal-code" />
                    {errors.postalCode && <p className="error">{errors.postalCode}</p>}
                  </div>
                </div>

                {errors.cart && <p className="error checkout-error">{errors.cart}</p>}
                <button className="check-checkout-button" type="submit">Pay Now</button>
              </form>

              <p><Link to="/returns" style={{ textDecoration: "underline" }} onClick={toTop}>
                Shipping & Returns Info
              </Link></p>
            </div>
          </div>

          {!sub && (
            <div className="right">
              <div className="check-order-summary">
                <div className="check-order-details">
                  {cartItems.map((item, index) => {
                    const product = getProductById(item.id);
                    if (!product || !product.images) return null;
                    return (
                      <div key={`${item.id}-${item.size}-${item.color}-${index}`} className="check-cart-item">
                        <img src={product.images[0]} alt={product.name} />
                        <div className="pro--qty"><div className="qty-inner">{item.quantity}</div></div>
                        <div className="check-item-details"><h3>
                          {product.name}
                          {item.size && <><br />Size: {item.size}</>}
                          {item.color && <><br />Color: {item.color}</>}
                        </h3></div>
                        <p className="cal-single">HK${product.price}</p>
                      </div>
                    );
                  })}
                  <div className="check-summary-details">
                    <div className="gridTotal"><table className="summary-details22">
                      <tbody className="sumTbody22"><tr className="sumTr22">
                        <th className="subtotalTh22" style={{ fontSize: "24px" }}>Total</th>
                        <th className="subtotalTxt22">HK${calculateTotal().toFixed(2)}</th>
                      </tr></tbody>
                    </table></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CheckOut;
